import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import QuestionCircleIcon from './../../assets/icons/QuestionCircle.svg?react'

export const CardTitleDescription = ({
    title,
    description,
    isBorder = false,
    size = 12,
    children,
}) => {
    return (
        <Grid
            size={size}
            sx={{
                borderRadius: '16px',
                padding: '16px',
                border: isBorder ? '1px solid #E9EAED' : 'none',
            }}>
            <Stack direction="row" sx={{ alignItems: 'center', mb: 1 }}>
                <Typography
                    variant="h5"
                    sx={{
                        color: '#181B25',
                    }}>
                    {title}
                </Typography>

                <Tooltip title={description}>
                    <IconButton>
                        <QuestionCircleIcon />
                    </IconButton>
                </Tooltip>
            </Stack>
            {children}
        </Grid>
    )
}
